import userAccessCode from './userAccessCode';
import surveyUserAccessCode from './surveyUserAccessCode';
import impersonate from './impersonate';

export default {
  ...userAccessCode,
  ...surveyUserAccessCode,
  api_r_open_rememberPassword_email: {
    path: 'remember-password/email/',
  },
  api_r_open_rememberPassword_set: {
    path: 'remember-password/set/',
  },
  ...impersonate,
};
